import { LicenseType } from "@/types";

export const LICENSE_TYPE_LIST_HREFS: Record<LicenseType, string> = {
  license: "/licenses",
  certificate: "/certificates",
  applicationForm: "/application-forms",
};

export const LICENSE_TYPE_CREATE_HREFS: Record<LicenseType, string> = {
  license: "/licenses/new",
  certificate: "/certificates/new",
  applicationForm: "/application-forms/new",
};

/**
 * The purchased-list route each license variant issues into. Mirrors the
 * `PurchasedLicensesPage` `basePath` props wired in `routes.tsx` — the page is
 * one component mounted at three paths, one per variant.
 */
export const LICENSE_TYPE_ISSUED_LIST_HREFS: Record<LicenseType, string> = {
  license: "/issued-licenses",
  certificate: "/issued-certificates",
  applicationForm: "/submitted-application-forms",
};
